import { useState } from 'react'
import { useLang } from '../i18n/LangProvider'
import { t, Lang } from './i18n'
import { formatDate, localeFor } from '../utils/format'
import dialogStyles from '../styles/Dialog.module.css'

export function NotaOverlay({
  jugadorNombre,
  fecha,
  lang: langProp,
  notaInicial,
  onSave,
  onDelete,
  onClose,
  esAdmin = false,
  onDeleteSesion,
  estadoActual,
  onMarcarFalta,
}: {
  jugadorNombre: string
  fecha: string
  lang?: Lang
  notaInicial: string
  onSave: (nota: string) => Promise<void>
  onDelete: () => Promise<void>
  onClose: () => void
  // Issue #65, 2026-10-09: "en UKE Eskola y F7, solo el administrador puede hacer esto" — borrar
  // la sesión completa (marca + nota) de una única persona, no solo su nota. El nombre de la prop
  // se mantiene genérico porque el 2026-10-11 se reutilizó también en la pestaña de Entrenadores,
  // donde quien puede escribir (y por tanto borrar) es el coordinador, no el admin — cada pantalla
  // decide qué valor le pasa según su propio criterio de acceso.
  esAdmin?: boolean
  onDeleteSesion?: () => Promise<void>
  // Club por WhatsApp, 2026-10-13 (Eskola/F7): marcar el motivo de la ausencia. Sin la prop (p. ej.
  // solo lectura o pestaña de entrenadores) no se muestran los botones.
  estadoActual?: string | null
  onMarcarFalta?: (estado: 'EN' | 'LS' | 'JU' | 'NJ') => Promise<void>
}) {
  const ctxLang = useLang()
  const lang = langProp ?? ctxLang
  const [nota, setNota] = useState(notaInicial)

  return (
    <dialog open onClose={onClose} className={dialogStyles.dialog}>
      <h3>{t('nota', lang)}</h3>
      <p>
        {jugadorNombre} · {formatDate(fecha, localeFor(lang))}
      </p>
      {onMarcarFalta && (
        <div className="modal-actions">
          <span>{t('faltaMotivo', lang)}</span>
          {(['EN', 'LS', 'JU', 'NJ'] as const).map((estado) => (
            <button key={estado} aria-pressed={estadoActual === estado} onClick={() => onMarcarFalta(estado)}>
              {t(`falta${estado}`, lang)}
            </button>
          ))}
        </div>
      )}
      <textarea rows={4} value={nota} onChange={(e) => setNota(e.target.value)} />
      <div className="modal-actions">
        <button onClick={() => onSave(nota)}>{t('guardar', lang)}</button>
        <button onClick={onDelete}>{t('eliminarNota', lang)}</button>
        {esAdmin && onDeleteSesion && (
          <button
            onClick={() => {
              if (window.confirm(t('eliminarSesionJugadorConfirm', lang))) onDeleteSesion()
            }}
          >
            {t('eliminarSesionJugador', lang)}
          </button>
        )}
        <button onClick={onClose}>{t('cerrar', lang)}</button>
      </div>
    </dialog>
  )
}
